export default __webpack_public_path__ + "static/media/IMG-activityPH_motor.1a5f044b.png";